import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrivacyPolicy() {
  return <div className="min-h-screen w-full bg-heliona-cream font-sans text-heliona-charcoal selection:bg-heliona-mint/30" data-id="element-1007">
      {/* Header */}
      <header className="w-full p-8 flex justify-between items-center max-w-5xl mx-auto" data-id="element-1008">
        <Link to="/" className="flex items-center gap-2 text-heliona-text-gray hover:text-heliona-charcoal transition-colors" data-id="element-1009">
          <ArrowLeft className="w-5 h-5" data-id="element-1010" />
          <span className="text-sm font-medium" data-id="element-1011">Back to Home</span>
        </Link>
        <div className="flex items-center" data-id="element-1012">
          <img src="https://cdn.magicpatterns.com/uploads/gsWfp7Yqa2Z6SBgP3SbdyL/HELIONA_transparent.png" alt="Heliona Logo" className="h-8 sm:h-10" data-id="element-1013" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12 sm:py-20" data-id="element-1014">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1015">
          <h1 className="text-4xl sm:text-5xl font-serif font-medium mb-4 text-heliona-charcoal" data-id="element-1016">
            Privacy Policy
          </h1>
          <p className="text-heliona-text-gray mb-12" data-id="element-1017">
            Last updated: February 12, 2026
          </p>

          <div className="prose prose-lg prose-headings:font-serif prose-headings:font-medium prose-headings:text-heliona-charcoal prose-p:text-heliona-text-gray prose-li:text-heliona-text-gray prose-strong:text-heliona-charcoal max-w-none" data-id="element-1018">
            <p data-id="element-1019">
              At Heliona ("we," "our," or "us"), we respect your privacy and are
              committed to protecting the personal information you share with
              us. This Privacy Policy explains how we collect, use, disclose,
              and safeguard your information when you visit our website or use
              our leadership development platform.
            </p>

            <h3 data-id="element-1020">1. Information We Collect</h3>
            <p data-id="element-1021">
              We collect information that you provide directly to us, such as
              when you create an account, participate in our assessments, or
              communicate with us. This may include:
            </p>
            <ul data-id="element-1022">
              <li data-id="element-1023">
                <strong data-id="element-1024">Personal Identification Information:</strong> Name,
                email address, job title, and company name.
              </li>
              <li data-id="element-1025">
                <strong data-id="element-1026">Assessment Data:</strong> Responses to leadership
                assessments, psychometric evaluations, and feedback surveys.
              </li>
              <li data-id="element-1027">
                <strong data-id="element-1028">Usage Data:</strong> Information about how you interact
                with our platform, including access times, pages viewed, and
                features used.
              </li>
            </ul>

            <h3 data-id="element-1029">2. How We Use Your Information</h3>
            <p data-id="element-1030">We use the information we collect to:</p>
            <ul data-id="element-1031">
              <li data-id="element-1032">Provide, maintain, and improve our services.</li>
              <li data-id="element-1033">
                Generate leadership insights and personalized development plans.
              </li>
              <li data-id="element-1034">
                Process transactions and send related information, including
                confirmations and invoices.
              </li>
              <li data-id="element-1035">
                Send you technical notices, updates, security alerts, and
                support messages.
              </li>
              <li data-id="element-1036">Respond to your comments, questions, and requests.</li>
            </ul>

            <h3 data-id="element-1037">3. Data Security</h3>
            <p data-id="element-1038">
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the Internet or electronic storage is 100%
              secure, and we cannot guarantee absolute security.
            </p>

            <h3 data-id="element-1039">4. Sharing of Information</h3>
            <p data-id="element-1040">
              We do not sell your personal information. We may share your
              information in the following circumstances:
            </p>
            <ul data-id="element-1041">
              <li data-id="element-1042">
                <strong data-id="element-1043">With Service Providers:</strong> We may share
                information with third-party vendors who provide services on our
                behalf, such as hosting, analytics, and customer support.
              </li>
              <li data-id="element-1044">
                <strong data-id="element-1045">For Legal Reasons:</strong> We may disclose information
                if we believe it is necessary to comply with a legal obligation,
                protect our rights or property, or prevent fraud or safety
                issues.
              </li>
              <li data-id="element-1046">
                <strong data-id="element-1047">Business Transfers:</strong> In connection with a
                merger, sale of company assets, financing, or acquisition of all
                or a portion of our business.
              </li>
            </ul>

            <h3 data-id="element-1048">5. Your Rights</h3>
            <p data-id="element-1049">
              Depending on your location, you may have certain rights regarding
              your personal information, including the right to access, correct,
              delete, or restrict the use of your data. To exercise these
              rights, please contact us at privacy@heliona.co.
            </p>

            <h3 data-id="element-1050">6. Cookies and Tracking Technologies</h3>
            <p data-id="element-1051">
              We use cookies and similar tracking technologies to track the
              activity on our service and hold certain information. You can
              instruct your browser to refuse all cookies or to indicate when a
              cookie is being sent.
            </p>

            <h3 data-id="element-1052">7. Changes to This Privacy Policy</h3>
            <p data-id="element-1053">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page
              and updating the "Last updated" date.
            </p>

            <h3 data-id="element-1054">8. Contact Us</h3>
            <p data-id="element-1055">
              If you have any questions about this Privacy Policy, please
              contact us at:
            </p>
            <p data-id="element-1056">
              <strong data-id="element-1057">Email:</strong> privacy@heliona.co
              <br data-id="element-1058" />
              <strong data-id="element-1059">Address:</strong> 123 Innovation Drive, Suite 400, San
              Francisco, CA 94105
            </p>
          </div>
        </motion.div>
      </main>

      <footer className="w-full py-8 text-center text-sm text-heliona-text-gray/60 border-t border-heliona-charcoal/5 mt-12" data-id="element-1060">
        <div className="max-w-5xl mx-auto px-8 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-1061">
          <p data-id="element-1062">&copy; {new Date().getFullYear()} Heliona. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-1063">
            <Link to="/privacy" className="hover:text-heliona-charcoal transition-colors" data-id="element-1064">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-heliona-charcoal transition-colors" data-id="element-1065">
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}